import React from 'react';
import './Blog.css';

import { extractDateParts } from '../../utils';

import { Link } from 'react-router-dom'; 



const Blog = ({ blog }) => {

  const {image, heading, content, category, admin, date} = blog; // Extracting data from blog
  const { day, shortMonth } = extractDateParts(date); // Extracting formatted date parts using utility function

  return (

    <div className='blog-item'>

      <span className='date'>{day} {shortMonth}</span> {/* Blog Date */}

      <div className='image'>
        <img src={image} alt='Blog' /> {/* Blog image */}
      </div>

      <div className='content'>

        <div className='details'>
          <h5 className='title'><Link to={`/Blogs/category/${category}`}>{category}</Link></h5> {/* Blog Category */}
          <h5 className='admin'><span>by {admin}</span></h5> {/* Blog Admin */}
        </div>

        {/* Blog Title with dynamic navigation */}
        <Link to={{
            pathname: '/Blogs/' + heading,
          }} 
          state= {blog}
          className='main-heading'>{heading}
        </Link>

        <p>{content}</p> {/* Blog Description */}

        {/* Blog Detail Page Link Button */}
        <Link to={{
            pathname: '/Blogs/' + heading,
          }} 
          state= {blog}
          className='btn'>Learn More
        </Link>
      </div>

    </div>
  )
}

export default Blog;